import { ReactElement } from 'react'
import { Stack } from '@mui/material'
import { DividerHeading, TwoColumnGrid } from '@ui2/structure'
import { CheckboxLabeled } from '@ui/actions'
import {
  getPositionListElementTypeVisibility,
  isOnlyShowElementsWithCommentEnabled,
  ONLY_SHOW_ELEMENTS_WITH_COMMENT_OPTION_KEY,
  POSITION_LIST_ELEMENT_TYPE_OPTIONS,
  togglePositionListElementType,
} from 'src/domain/planTables/constants'
import type { PlanTableTemplateOptions } from 'src/domain/planTables/types'

interface Props {
  templateOptions: PlanTableTemplateOptions | undefined
  onChange: (templateOptions: PlanTableTemplateOptions) => void
}

const PositionListTemplateOptionsFields = ({ templateOptions, onChange }: Props): ReactElement => {
  const onlyShowElementsWithComment = isOnlyShowElementsWithCommentEnabled(templateOptions)
  const elementTypes = getPositionListElementTypeVisibility(templateOptions)

  return (
    <Stack spacing={1} data-cy="plan-table-position-list-options">
      <CheckboxLabeled
        checked={onlyShowElementsWithComment}
        onChange={event =>
          onChange({
            ...templateOptions,
            [ONLY_SHOW_ELEMENTS_WITH_COMMENT_OPTION_KEY]: event.target.checked,
          })
        }
        label="Nur Elemente mit Kommentar anzeigen"
        data-cy="plan-table-only-show-elements-with-comment"
      />

      <Stack spacing={0.25}>
        <DividerHeading spacingTop={0}>Elementtypen in Tabelle</DividerHeading>
        <TwoColumnGrid fillColumnsFirst>
          {POSITION_LIST_ELEMENT_TYPE_OPTIONS.map(({ value, label }) => (
            <CheckboxLabeled
              key={value}
              checked={elementTypes[value]}
              onChange={() => onChange(togglePositionListElementType(templateOptions, value))}
              label={label}
              data-cy={`plan-table-position-list-element-type-${value}`}
            />
          ))}
        </TwoColumnGrid>
      </Stack>
    </Stack>
  )
}

export default PositionListTemplateOptionsFields
